export const parseCookies = (cookies) => {
	const list = {};

	if (!cookies) return list;

	cookies.split(';').forEach((cookie) => {
		const parts = cookie.split('=');
		const key = parts[0];
		const value = decodeURIComponent(parts.slice(1).join('='));
		list[key.trim()] = value;
	});

	return list;
};

export const getCookie = (name) => {
	if (process.client) {
		const cookies = parseCookies(document.cookie);
		return cookies[name];
	}
};

export const setCookie = (name, value, days) => {
	if (!process.client) return;
	let expires;
	if (days) {
		let date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toGMTString();
	} else {
		expires = '';
	}
	document.cookie = name + '=' + value + expires + '; path=/';
};
